import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from '../../service/account.service';
import { Observable, of } from 'rxjs';
import { TypeGroupIds } from 'src/app/modules/shared/constants/category-groupid.constants';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  localAppUrl = "";
  questionnaireURL = "";
  user: any;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.localAppUrl = environment.localApiUrl;
    this.questionnaireURL = environment.baseUrl + "LionO360ApplicationQuestionnaireAPI/LionO360/2.0/API/";
  }

  getLoggedUser(userId) {
    return this.http.get<any>(this.localAppUrl + 'users/' + userId)
        .toPromise()
        .then(res => res);
  }

  getAllQuestionnaires(companyID) {
    return this.http.get<any>(this.questionnaireURL + "Questionnaire?OrganizationId=" + companyID)
        .toPromise()
        .then(res => res);
  }
  getQuestionnaireCounts(id){
    return this.http.get<any>(this.questionnaireURL + "Questionnaire/" + "GetQuestionnaireWithQuestionAnswersById/" + id)
    .toPromise()
    .then(res => res);
  }

  getAllQuestionnairesByPageNumber(pageNo,pageSize,filters,globalSearch,sortBy,searchColumn,searchValue) {

  let params = new HttpParams();
  params = (!pageNo? params : params.append('pageNumber', pageNo))
  params = (!pageSize? params : params.append('pageSize', pageSize))
  params = (params.append('IsAscending', sortBy))
  params = (!globalSearch? params : params.append('globalSearch', globalSearch))
  params = (!searchColumn? params : params.append('SearchColumns', searchColumn))
  params = (!searchValue? params : params.append('SearchValue', searchValue))
  params = (!filters? params : params.append('filters', filters))
    return this.http.get<any>(this.questionnaireURL + "Questionnaire/All", {observe: 'response' ,params})
        .toPromise()
        .then(res =>  ({
          questionnaires: res.body,
          headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
      }));



  }

  // getAllQuestionnairesByPageNumber(pageNo,pageSize,filters,globalSearch,sortBy,searchColumn,searchValue): Observable<any> {

  //   let params = new HttpParams();
  //   params = (!pageNo? params : params.append('pageNumber', pageNo))
  //   params = (!pageSize? params : params.append('pageSize', pageSize))
  //   params = (params.append('IsAscending', sortBy))
  //   params = (!globalSearch? params : params.append('globalSearch', globalSearch))
  //   params = (!searchColumn? params : params.append('SearchColumns', searchColumn))
  //   params = (!searchValue? params : params.append('SearchValue', searchValue))
  //   params = (!filters? params : params.append('filters', filters))
  //     return this.http.get<any>(this.questionnaireURL + "Questionnaire/All", {params})

  //   }

  getQuestionnaireVisitTypes(){
    return this.http.get<any>(`${this.questionnaireURL}Type?groupId=${TypeGroupIds.QuestionaireTypeOrganizationAPI}`)
  }

  createVisit(data){
    return this.http.post<any>(`${this.questionnaireURL}Visit`, data)
  }

  getVisitById(id){
    return this.http.get<any>(`${this.questionnaireURL}Visit/${id}`)
  }

  submitQuestionnaire(data){
    return this.http.post<any>(`${this.questionnaireURL}SurveyQuestion/AddMultipleQuestionAnswers`, data)
  }

  checkoutQuestionnaire(data){
    return this.http.put<any>(`${this.questionnaireURL}Visit`, data)
  }
}
